<span style="width: 100%;display: inline-block;text-align: right;">{{modelValue.Value | currency:'EUR':'symbol-narrow'}}<span>


// WEBPACK FOOTER //
// ./src/app/shared/grid/renderer/money-renderer.component.ts.MoneyRendererComponent.html